import { defineMessages } from 'react-intl';
import type { MessageValue } from 'react-intl';

export const actionButtonMessages = defineMessages<{
  readonly increase: { readonly step: MessageValue };
  readonly decrease: { readonly step: MessageValue };
}>({
  increase: {
    id: 'quantitySelection.increase',
    defaultMessage: 'Anzahl um {step} erhöhen',
  },
  decrease: {
    id: 'quantitySelection.decrease',
    defaultMessage: 'Anzahl um {step} verringern',
  },
});
